import React from 'react'

const PencilIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" fillOpacity=".65" d="M19.472 3.809c-1.078-1.079-2.826-1.079-3.905 0L4.62 14.755c-.075.075-.13.168-.158.27l-1.44 5.197c-.059.214.001.442.158.598.156.157.384.217.597.158l5.198-1.44c.102-.028.195-.082.27-.157L20.192 8.434c1.077-1.08 1.077-2.826 0-3.905l-.72-.72zM5.957 15.154l8.96-8.959 2.889 2.89-8.96 8.959-2.89-2.89zm-.578 1.158l2.309 2.309-3.193.885.884-3.194zm13.946-8.746l-.651.65-2.89-2.889.651-.65c.6-.6 1.57-.6 2.17 0l.72.72c.598.6.598 1.57 0 2.169z"/>
  </svg>
)

export default PencilIcon
